export default __webpack_public_path__ + "static/media/fad-digital4.bab0384e.svg";